import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {CheckoutInfoMessageProps} from '@Components/checkout-flow/components/checkout-info-message/checkout-info-message.types';
import {CHECKOUT_INFO_MESSAGE_ICON, CHECKOUT_INFO_MESSAGE_TEXT_CLASS, CheckoutInfoMessageTone} from '@Components/checkout-flow/components/checkout-info-message/checkout-info-message.types';
import styles from './checkout-info-message.module.scss';

export function CheckoutInfoMessage({message, tone = CheckoutInfoMessageTone.NEUTRAL, className = '', textClassName = ''}: CheckoutInfoMessageProps): ReactElement {
  const colorClass = CHECKOUT_INFO_MESSAGE_TEXT_CLASS[tone];

  return (
    <div className={`${styles.container} ${className}`}>
      <Icon icon={CHECKOUT_INFO_MESSAGE_ICON[tone]} size={IconSize.SIZE_ICON_16} className={`${colorClass} ${styles.icon}`} ariaHidden />
      <Text val={message} size={TextSize.SM} className={`${colorClass} ${textClassName}`} dangerouslySetInnerHTML />
    </div>
  );
}
